import { ContainerStatusEnum } from "../enum/ContainerStatusEnum";

export class ContainerStatusGroup {
    static readonly ImportActive: Array<{
        name: ContainerStatusEnum;
    }> = [
            { name: ContainerStatusEnum.Inbound },
            { name: ContainerStatusEnum.Arrived },
            { name: ContainerStatusEnum.Wharf },
            { name: ContainerStatusEnum.Available }
        ];

    static readonly ExportActive: Array<{
        name: ContainerStatusEnum;
    }> = [
            { name: ContainerStatusEnum.ShipAtWharf },
            { name: ContainerStatusEnum.Wharf },
            { name: ContainerStatusEnum.OnVessel },
            { name: ContainerStatusEnum.Departed },
            { name: ContainerStatusEnum.Missed }
        ];
    static readonly ExportSaw: Array<{
        name: ContainerStatusEnum;
    }> = [
            { name: ContainerStatusEnum.Wharf },
            { name: ContainerStatusEnum.OnVessel },
            { name: ContainerStatusEnum.Departed },
            { name: ContainerStatusEnum.Missed },
            { name: ContainerStatusEnum.Active }
        ];
    static readonly ImportInbound: Array<{
        name: ContainerStatusEnum;
    }> = [
            { name: ContainerStatusEnum.Arrived },
            { name: ContainerStatusEnum.Wharf },
            { name: ContainerStatusEnum.Available },
            { name: ContainerStatusEnum.GateOut },
            { name: ContainerStatusEnum.Active }
        ];

    static readonly ImportArrived: Array<{
        name: ContainerStatusEnum;
    }> = [
            { name: ContainerStatusEnum.Wharf },
            { name: ContainerStatusEnum.Available },
            { name: ContainerStatusEnum.GateOut },
            { name: ContainerStatusEnum.Active },
            { name: ContainerStatusEnum.Inbound }
        ];

    static readonly ImportWharf: Array<{
        name: ContainerStatusEnum;
    }> = [
            { name: ContainerStatusEnum.Available },
            { name: ContainerStatusEnum.GateOut },
            { name: ContainerStatusEnum.Active },
            { name: ContainerStatusEnum.Inbound },
            { name: ContainerStatusEnum.Arrived }
        ];

    static readonly ExportWharf: Array<{
        name: ContainerStatusEnum;
    }> = [
            { name: ContainerStatusEnum.OnVessel },
            { name: ContainerStatusEnum.Departed },
            { name: ContainerStatusEnum.Missed },
            { name: ContainerStatusEnum.Active },
            { name: ContainerStatusEnum.ShipAtWharf }
        ];

    static readonly ExportVessel: Array<{
        name: ContainerStatusEnum;
    }> = [
            { name: ContainerStatusEnum.Departed },
            { name: ContainerStatusEnum.Missed },
            { name: ContainerStatusEnum.Active },
            { name: ContainerStatusEnum.ShipAtWharf },
            { name: ContainerStatusEnum.Wharf },
        ];

    static readonly ExportDeparted: Array<{
        name: ContainerStatusEnum;
    }> = [
            { name: ContainerStatusEnum.Missed },
            { name: ContainerStatusEnum.Active },
            { name: ContainerStatusEnum.ShipAtWharf },
            { name: ContainerStatusEnum.Wharf },
            { name: ContainerStatusEnum.OnVessel },
        ];

    static readonly ExportMissed: Array<{
        name: ContainerStatusEnum;
    }> = [
            { name: ContainerStatusEnum.Active },
            { name: ContainerStatusEnum.ShipAtWharf },
            { name: ContainerStatusEnum.Wharf },
            { name: ContainerStatusEnum.OnVessel },
            { name: ContainerStatusEnum.Departed },
        ];

    static readonly ExportHold: Array<{
        name: ContainerStatusEnum;
    }> = [
            { name: ContainerStatusEnum.ShipAtWharf },
            { name: ContainerStatusEnum.Wharf },
            { name: ContainerStatusEnum.OnVessel },
            { name: ContainerStatusEnum.Departed },
        ];

    static readonly ImportHold: Array<{
        name: ContainerStatusEnum;
    }> = [
            { name: ContainerStatusEnum.Available }
        ];

    static readonly ImportAvailable: Array<{
        name: ContainerStatusEnum;
    }> = [
            { name: ContainerStatusEnum.GateOut },
            { name: ContainerStatusEnum.Active },
            { name: ContainerStatusEnum.Inbound },
            { name: ContainerStatusEnum.Arrived },
            { name: ContainerStatusEnum.OnRail }
        ];
    static readonly ReadyForPickup: Array<{
        name: ContainerStatusEnum;
    }> = [
            { name: ContainerStatusEnum.ReadyForPickup }
        ];
    static readonly Unpack: Array<{
        name: ContainerStatusEnum;
    }> = [
            { name: ContainerStatusEnum.Unpack }
        ];
    static readonly Packed: Array<{
        name: ContainerStatusEnum;
    }> = [
            { name: ContainerStatusEnum.Pack }
        ];
    static readonly ImportGateOut: Array<{
        name: ContainerStatusEnum;
    }> = [
            { name: ContainerStatusEnum.OnRail },
            { name: ContainerStatusEnum.Available },
            { name: ContainerStatusEnum.Arrived },
            { name: ContainerStatusEnum.Wharf },
            { name: ContainerStatusEnum.Inbound },
        ];

    static readonly ImportOnRail: Array<{
        name: ContainerStatusEnum;
    }> = [
            { name: ContainerStatusEnum.Available },
            { name: ContainerStatusEnum.Arrived },
            { name: ContainerStatusEnum.Wharf },
            { name: ContainerStatusEnum.Inbound },
        ];
    static readonly ImportUnknown: Array<{
        name: ContainerStatusEnum;
    }> = [
            { name: ContainerStatusEnum.Active },
            { name: ContainerStatusEnum.GateOut },
            { name: ContainerStatusEnum.OnRail },
            { name: ContainerStatusEnum.Available },
            { name: ContainerStatusEnum.Arrived },
            { name: ContainerStatusEnum.Wharf },
            { name: ContainerStatusEnum.Inbound },
            { name: ContainerStatusEnum.Hold },
        ];

    static readonly ExportUnknown: Array<{
        name: ContainerStatusEnum;
    }> = [
            { name: ContainerStatusEnum.Active },
            { name: ContainerStatusEnum.ShipAtWharf },
            { name: ContainerStatusEnum.Wharf },
            { name: ContainerStatusEnum.OnVessel },
            { name: ContainerStatusEnum.Departed },
            { name: ContainerStatusEnum.Missed },
            { name: ContainerStatusEnum.Hold },
        ];
}